import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { components } from 'react-select';
import kebabCase from 'lodash/kebabCase.js';
import { SelectCheckboxOption } from './SelectCheckboxOption.js';
import { SelectClearTooltip } from './SelectClearTooltip.js';
import PropTypes from 'prop-types';
import { Chip } from '../../Chip/component.js';
import { DesignSystem } from '@everfi/design-system';
var DropdownIndicator = components.DropdownIndicator,
  IndicatorsContainer = components.IndicatorsContainer,
  IndicatorSeparator = components.IndicatorSeparator,
  MenuList = components.MenuList,
  SelectContainer = components.SelectContainer,
  SingleValue = components.SingleValue,
  ValueContainer = components.ValueContainer;
var SelectComponentWrapper = function SelectComponentWrapper(_ref) {
  var _selectProps$name$rep, _selectProps$name, _selectProps$name$rep2;
  var _ref$Component = _ref.Component,
    Component = _ref$Component === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null) : _ref$Component,
    _ref$componentName = _ref.componentName,
    componentName = _ref$componentName === void 0 ? '' : _ref$componentName,
    _ref$componentProps = _ref.componentProps,
    componentProps = _ref$componentProps === void 0 ? {} : _ref$componentProps,
    _ref$wrapperAttribute = _ref.wrapperAttributes,
    wrapperAttributes = _ref$wrapperAttribute === void 0 ? {} : _ref$wrapperAttribute,
    _ref$wrapperStyle = _ref.wrapperStyle,
    wrapperStyle = _ref$wrapperStyle === void 0 ? {} : _ref$wrapperStyle;
  var selectProps = componentProps.selectProps;
  var formattedName = (_selectProps$name$rep = selectProps === null || selectProps === void 0 || (_selectProps$name = selectProps.name) === null || _selectProps$name === void 0 || (_selectProps$name$rep2 = _selectProps$name.replace) === null || _selectProps$name$rep2 === void 0 ? void 0 : _selectProps$name$rep2.call(_selectProps$name, '[]', '')) !== null && _selectProps$name$rep !== void 0 ? _selectProps$name$rep : '';
  var name = formattedName ? "-".concat(formattedName) : '';
  var dataObjectId = "Select".concat(name, "-").concat(componentName);
  return /*#__PURE__*/React.createElement("div", _extends({}, wrapperAttributes, {
    "data-object-id": dataObjectId,
    style: wrapperStyle
  }), /*#__PURE__*/React.createElement(Component, componentProps));
};
SelectComponentWrapper.displayName = "SelectComponentWrapper";
var DropdownIndicatorWrapper = function DropdownIndicatorWrapper(props) {
  return /*#__PURE__*/React.createElement(SelectComponentWrapper, {
    Component: DropdownIndicator,
    componentName: "dropdown-indicator",
    componentProps: props
  });
};
DropdownIndicatorWrapper.displayName = "DropdownIndicatorWrapper";
var IndicatorsContainerWrapper = function IndicatorsContainerWrapper(props) {
  return /*#__PURE__*/React.createElement(SelectComponentWrapper, {
    Component: IndicatorsContainer,
    componentName: "indicators",
    componentProps: props
  });
};
IndicatorsContainerWrapper.displayName = "IndicatorsContainerWrapper";
var IndicatorsSeparatorWrapper = function IndicatorsSeparatorWrapper(props) {
  return /*#__PURE__*/React.createElement(SelectComponentWrapper, {
    Component: IndicatorSeparator,
    componentName: "indicator-separator",
    componentProps: props
  });
};
IndicatorsSeparatorWrapper.displayName = "IndicatorsSeparatorWrapper";
var MenuListWrapper = function MenuListWrapper(props) {
  return /*#__PURE__*/React.createElement(SelectComponentWrapper, {
    Component: MenuList,
    componentName: "menu-list",
    componentProps: props
  });
};
MenuListWrapper.displayName = "MenuListWrapper";
var MultiValueWrapper = function MultiValueWrapper() {
  var _props$data;
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var children = props.children,
    removeProps = props.removeProps;
  var label = (props === null || props === void 0 || (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.label) || children;
  var wrapperAttributes = {
    'data-component-type': "".concat(kebabCase(label), "-chip")
  };
  var componentProps = {
    value: label,
    onRemove: removeProps === null || removeProps === void 0 ? void 0 : removeProps.onClick,
    sx: {
      mr: DesignSystem.Space.XS,
      mb: DesignSystem.Space.XS
    }
  };
  return /*#__PURE__*/React.createElement(SelectComponentWrapper, {
    Component: Chip,
    componentName: "multi-value",
    componentProps: componentProps,
    wrapperAttributes: wrapperAttributes
  });
};
MultiValueWrapper.displayName = "MultiValueWrapper";
var SelectContainerWrapper = function SelectContainerWrapper(props) {
  return /*#__PURE__*/React.createElement(SelectComponentWrapper, {
    Component: SelectContainer,
    componentName: "container",
    componentProps: props
  });
};
SelectContainerWrapper.displayName = "SelectContainerWrapper";
var SingleValueWrapper = function SingleValueWrapper() {
  var _props$data2;
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wrapperAttributes = {
    'data-component-type': "".concat(kebabCase(props === null || props === void 0 || (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.label), "-value")
  };
  return /*#__PURE__*/React.createElement(SelectComponentWrapper, {
    Component: SingleValue,
    componentName: "single-value",
    componentProps: props,
    wrapperAttributes: wrapperAttributes,
    wrapperStyle: {
      gridArea: '1/1/2/3'
    }
  });
};
SingleValueWrapper.displayName = "SingleValueWrapper";
var ValueContainerWrapper = function ValueContainerWrapper(props) {
  return /*#__PURE__*/React.createElement(SelectComponentWrapper, {
    Component: ValueContainer,
    componentName: "value-container",
    componentProps: props
  });
};
ValueContainerWrapper.displayName = "ValueContainerWrapper";
var propTypes = {
  Component: PropTypes.func,
  componentName: PropTypes.string,
  componentProps: PropTypes.object,
  data: PropTypes.shape({
    label: PropTypes.string
  }),
  wrapperAttributes: PropTypes.object,
  wrapperStyle: PropTypes.object
};
SelectComponentWrapper.propTypes = propTypes;
DropdownIndicatorWrapper.propTypes = propTypes;
IndicatorsContainerWrapper.propTypes = propTypes;
IndicatorsSeparatorWrapper.propTypes = propTypes;
MenuListWrapper.propTypes = propTypes;
MultiValueWrapper.propTypes = propTypes;
SelectContainerWrapper.propTypes = propTypes;
SingleValueWrapper.propTypes = propTypes;
ValueContainerWrapper.propTypes = propTypes;
var selectComponents = {
  DropdownIndicator: DropdownIndicatorWrapper,
  IndicatorsContainer: IndicatorsContainerWrapper,
  IndicatorSeparator: IndicatorsSeparatorWrapper,
  MenuList: MenuListWrapper,
  MultiValue: MultiValueWrapper,
  Option: SelectCheckboxOption,
  SelectContainer: SelectContainerWrapper,
  SingleValue: SingleValueWrapper,
  ValueContainer: ValueContainerWrapper,
  ClearIndicator: SelectClearTooltip
};
export { DropdownIndicatorWrapper, IndicatorsContainerWrapper, IndicatorsSeparatorWrapper, MenuListWrapper, MultiValueWrapper, SelectContainerWrapper, SingleValueWrapper, ValueContainerWrapper, selectComponents };